export const EMAIL_VERIFICATION = "EMAIL_VERIFICATION";
export const getEmailVerification = (data) => {
    return {
        type: EMAIL_VERIFICATION,
        payload: data
    }
}